export function useApiParameters(
	userId: string | null,
	token: string | null,
): { userId: string; token: string } {
	if (!userId) {
		throw new Error(
			"User not authenticated - userId is null. This usually means Clerk authentication hasn't loaded yet.",
		);
	}
	if (!token) {
		throw new Error(
			"Token not available - getToken returned null. This usually means the user is not signed in or the token couldn't be retrieved.",
		);
	}
	return {
		userId,
		token,
	};
}
